import React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/joy/Typography';
import { CircularProgress } from '@mui/joy';

export const TASK_RESULT_DRAWER_CONTENT_HEIGHT = '60vh';

const placeholderSx = {
  bgcolor: 'background.level2',
  borderRadius: 'sm',
};

const cardPlaceholderSx = {
  ...placeholderSx,
  border: '1px solid',
  borderColor: 'divider',
};

const TaskResultDrawerLoadingShell = () => (
  <Box data-testid="task-result-drawer-loading-shell">
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 2, gap: 2 }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box sx={{ ...placeholderSx, width: 120, height: 28 }} />
        <Box sx={{ ...placeholderSx, width: 96, height: 24 }} />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1.5}>
        <CircularProgress size="sm" />
        <Typography level="body-sm" color="neutral" aria-live="polite">
          Loading task result...
        </Typography>
      </Stack>
    </Stack>

    <Box
      sx={{
        maxHeight: TASK_RESULT_DRAWER_CONTENT_HEIGHT,
        overflow: 'hidden',
        overflowX: 'hidden',
      }}
    >
      <Grid container spacing={2} sx={{ height: '100%', minWidth: 0 }}>
        <Grid size={{ lg: 6, md: 12 }} sx={{ height: TASK_RESULT_DRAWER_CONTENT_HEIGHT, minWidth: 0 }}>
          <Box sx={{ ...cardPlaceholderSx, width: '100%', height: '100%' }} />
        </Grid>

        <Grid size={{ lg: 6, md: 12 }} sx={{ height: TASK_RESULT_DRAWER_CONTENT_HEIGHT, minWidth: 0 }}>
          <Stack spacing={2} sx={{ height: '100%', pr: 1, minWidth: 0 }}>
            <Box sx={{ ...cardPlaceholderSx, height: 152, flexShrink: 0 }} />
            <Box sx={{ ...cardPlaceholderSx, minHeight: 232, flexGrow: 1 }} />
            <Box sx={{ ...cardPlaceholderSx, height: 152, flexShrink: 0 }} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default TaskResultDrawerLoadingShell;
